// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__7TXVW","amount":"Amount_amount__1oqCf","tip":"Amount_tip__v-G0l","tipHeader":"Amount_tipHeader__3rM4-","tipsWrap":"Amount_tipsWrap__11lNQ"};